import Constant from '../lib/constant';
import axiosClient from './axiosClient';

const url = Constant.apiUrl + '/backup';

const backupApi = {
  // GET /backups
  list: () => axiosClient.get(url),

  // POST /backups
  create: () => axiosClient.post(url),

  // GET /backups/:name/download  (blob)
  download: (name) =>
    axiosClient.get(url + `/${encodeURIComponent(name)}/download`, {
      responseType: 'blob',
    }),

  // GET /backups/latest/download (blob)
  downloadLatest: () =>
    axiosClient.get(url + `/latest/download`, {
      responseType: 'blob',
    }),

  // DELETE /backups/:name
  delete: (name) => axiosClient.delete(url + `/${encodeURIComponent(name)}`),
};

export default backupApi;
